import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllDifferenceStocks = createAsyncThunk(
  "SaleOrder/FindAllDifferenceStock",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/SaleOrder/FindAllDifferenceStock`
      );
      const result = response.data?.Data;
      return result
        ? result?.map((stock: any, index: number) => {
            return {
              uniqueKey: index + 1,
              id: stock?.id ? +stock?.id : null,
              accountid: stock?.accountid ? +stock?.accountid : null,
              date: stock?.date ? stock?.date : "",
              account_name: stock?.account_name ? stock?.account_name : "",
              user_type: stock?.user_type ? stock?.user_type : "",
            };
          })
        : [];
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Difference Stock:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createDifferenceStock = createAsyncThunk(
  "SaleOrder/InsertDifferenceStock",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/InsertDifferenceStock`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error inserting Difference stock:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateDifferenceStock = createAsyncThunk(
  "SaleOrder/UpdateDifferenceStock",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/UpdateDifferenceStock`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Difference stock:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteDifferenceStock = createAsyncThunk(
  "SaleOrder/DeleteDifferenceStock",
  async (id: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/DeleteDifferenceStock`,
        { id: id }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Difference stock:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDifferenceStockByID = createAsyncThunk(
  "SaleOrder/FindByIDDifferenceStock",
  async (id: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/FindByIDDifferenceStock`,
        { id: id }
      );
      const result = response.data?.Data as any;
      return {
        id: result?.id,
        accountid: result?.accountid,
        vendor_options: result?.vendor_options,
        date: result?.date ? moment(result?.date, "YYYY-MM-DD").toDate() : "",
        difference_stock: result?.difference_stock
          ? result?.difference_stock?.map((orderitem: any) => {
              return {
                item_group_id: orderitem?.item_group_id
                  ? orderitem?.item_group_id
                  : null,
                item_group: orderitem?.item_group ? orderitem?.item_group : "",
                item_margin_rate: orderitem?.difference_stock_list
                  ? orderitem?.difference_stock_list?.map((subitem: any) => {
                      return {
                        id: subitem?.id ? +subitem?.id : null,
                        item_id: subitem?.item_id ? +subitem?.item_id : null,
                        item_group_id: subitem?.item_group_id
                          ? +subitem?.item_group_id
                          : null,
                        product_name: subitem?.product_name
                          ? subitem?.product_name
                          : "",
                        mrp: subitem?.mrp ? +subitem?.mrp : null,
                        quantity: subitem?.quantity ? +subitem?.quantity : null,
                        current_stock: subitem?.current_stock
                          ? +subitem?.current_stock
                          : null,
                        unit_id: subitem?.unit_id ? +subitem?.unit_id : null,
                        unit_name: subitem?.unit_name ? subitem?.unit_name : "",
                        rate: subitem?.rate ? +subitem?.rate : null,
                        amount: subitem?.total_amount
                          ? +subitem?.total_amount
                          : null,
                        // gst_id: subitem?.gst_id ? +subitem?.gst_id : null,
                        // gst: subitem?.gst ? +subitem?.gst : null,
                      };
                    })
                  : [],
              };
            })
          : [],
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching difference stock:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllDistributorRetailerMarginRates = createAsyncThunk(
  "ItemGroup/DistributerRetailerMarginRates",
  async (isdistributer: boolean) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ItemGroup/DistributerRetailerMarginRates`,
        {
          isdistributer: isdistributer,
        }
      );
      const result = response.data?.Data;
      return result.map((item: any) => {
        return {
          item_group_id: item?.item_group_id,
          item_group: item?.item_group,
          item_margin_rate: item?.item_margin_rate
            ? item?.item_margin_rate?.map((subitem: any) => {
                return {
                  item_id: subitem?.item_id ? +subitem?.item_id : null,
                  unit_id: subitem?.unit_id ? +subitem?.unit_id : null,
                  unit_decimal: subitem?.unit_decimal
                    ? +subitem?.unit_decimal
                    : 0,
                  unit_name: subitem?.unit_name ? subitem?.unit_name : "",
                  unit_code: subitem?.unit_code ? subitem?.unit_code : "",
                  item_group_id: subitem?.item_group_id
                    ? +subitem?.item_group_id
                    : null,
                  product_name: subitem?.product_name
                    ? subitem?.product_name
                    : "",
                  mrp: subitem?.mrp ? +subitem?.mrp : null,
                  current_stock: subitem?.current_stock
                    ? +subitem?.current_stock
                    : 0,
                  rate: subitem?.rate ? +subitem?.rate : null,
                  retail_margin: subitem?.retail_margin
                    ? +subitem?.retail_margin
                    : null,
                  retail_rate_include_gst: subitem?.retail_rate_include_gst
                    ? +subitem?.retail_rate_include_gst
                    : null,
                  retail_sgst: subitem?.retail_sgst
                    ? +subitem?.retail_sgst
                    : null,
                  retail_cgst: subitem?.retail_cgst
                    ? +subitem?.retail_cgst
                    : null,
                  retail_rate_exclude_gst: subitem?.retail_rate_exclude_gst
                    ? +subitem?.retail_rate_exclude_gst
                    : null,
                  distributor_rate_include_gst:
                    subitem?.distributor_rate_include_gst
                      ? +subitem?.distributor_rate_include_gst
                      : null,
                  distributor_sgst: subitem?.distributor_sgst
                    ? +subitem?.distributor_sgst
                    : null,
                  distributor_cgst: subitem?.distributor_cgst
                    ? +subitem?.distributor_cgst
                    : null,
                  distributor_rate: subitem?.distributor_rate
                    ? +subitem?.distributor_rate
                    : null,
                  gst_id: subitem?.gst_id ? +subitem?.gst_id : null,
                  gst: subitem?.gst ? +subitem?.gst : null,
                };
              })
            : [],
        };
      });
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Item Margin Rates:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDistributorCurrentStock = createAsyncThunk(
  "SaleOrder/FindByIDCurrentStock",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/SaleOrder/FindByIDCurrentStock`,
        formdata
      );
      const result = response.data?.Data;

      return {
        accountid: result?.accountid,
        account_name: result?.account_name,
        date: result?.date ? moment(result?.date, "YYYY-MM-DD").toDate() : "",
        Details: result?.Details,
        item_data: result?.item_data
          ? result?.item_data?.map((subitem: any) => {
              return {
                item_id: subitem?.item_id ? +subitem?.item_id : null,
                quantity: subitem?.quantity ? +subitem?.quantity : null,
              };
            })
          : [],
      };
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Distributor Current Stock:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
